import { isNotReadyStatus } from 'dashboard/helper/phoneHelper';

export const getStatusPriority = (status, customStatuses = []) => {
  if (['OTHER_CALL', 'QUEUE_CALL'].includes(status)) return 1;
  if (
    ['MIXED', 'ONLINE'].includes(status) ||
    status === 'CHAT_BUSY' ||
    isNotReadyStatus(status, customStatuses)
  ) {
    return 2;
  }
  if (status === 'READY' || status === 'CHAT_ONLINE') return 3;
  if (status === 'PARTIALLY_READY') return 4;
  if (status === 'OFFLINE' || status === 'CHAT_OFFLINE') return 5;
  if (status === 'NO_ACCESS') return 6;
  return 3;
};

// Returns 'PARTIALLY_READY' | 'MIXED' | null based on the per-queue statuses
// of an agent. Returns null when no override should be applied.
export const deriveCrossQueueStatus = queueStatuses => {
  if (!Array.isArray(queueStatuses) || queueStatuses.length <= 1) return null;

  const hasReady = queueStatuses.some(s => s === 'READY');
  const hasNonReady = queueStatuses.some(s => s !== 'READY');
  const hasOffline = queueStatuses.some(s => s === 'OFFLINE');
  const distinctStatuses = new Set(queueStatuses);

  if (hasReady && hasNonReady) return 'PARTIALLY_READY';
  if (!hasOffline && !hasReady && distinctStatuses.size > 1) return 'MIXED';
  return null;
};
